const API = require('jiji/infra/api/user');
const User = require('jiji/domain/entity/user');

class Repository {
    constructor() {
        this._loginUserPromise = null;
    }

    getLoginUser() {
        if(this._loginUserPromise) {
            return this._loginUserPromise;
        }
        this._loginUserPromise = new Promise((resolve, reject) => {
            API.getUser()
                .then(user => {
                    this._loginUser = this.buildUser(user);
                    resolve(this._loginUser);
                }, (reason) => {
                    const status = reason.status;
                    if(status === 401) {
                        resolve(null);
                    }
                    else {
                        reject(status);
                    }
                });
        });
        return this._loginUserPromise;
    }

    buildUser(userJson) {
        let u = new User(userJson);
        return u;
    }
}

module.exports = new Repository();



// WEBPACK FOOTER //
// ./jiji/domain/repository/user.js